__turbopack_context__.v({
  "imgCont": "R1WithM1Section-module__8XyfSq__imgCont",
  "imgCont2": "R1WithM1Section-module__8XyfSq__imgCont2",
  "imgContainer": "R1WithM1Section-module__8XyfSq__imgContainer",
  "root": "R1WithM1Section-module__8XyfSq__root",
  "sticky": "R1WithM1Section-module__8XyfSq__sticky",
  "textContent1": "R1WithM1Section-module__8XyfSq__textContent1",
});
